import { AccountSettings } from "01Data/Account";
import { AppContext } from "01Data/AppData";
import MenuIcon from "@mui/icons-material/Menu";
import {
  AppBar,
  IconButton,
  styled,
  Toolbar,
  Typography,
  TypographyProps,
} from "@mui/material";
import { useContext, useEffect, useState } from "react";

const MyAppBar = styled(AppBar)(({ theme }) => ({
  zIndex: theme.zIndex.drawer + 1,
  transition: theme.transitions.create(["width", "margin"], {
    easing: theme.transitions.easing.sharp,
    duration: theme.transitions.duration.leavingScreen,
  }),
}));

const MyToolBar = styled(Toolbar)(({ theme }) => ({
  paddingRight: 24,
}));

const MyIconButton = styled(IconButton)(({ theme }) => ({
  marginRight: 36,
}));

const MyTypography = styled(Typography)<
  TypographyProps<"h1", { component: "h1" }>
>(({ theme }) => ({
  flexGrow: 1,
}));

type Props = {
  open: boolean;
  setOpen: any;
};

const Header = (props: Props) => {
  const a = useContext(AppContext).account;
  const [name, setName] = useState("");

  useEffect(() => {
    a.GetAttributes().then((settings: AccountSettings) => {
      setName(`${settings.lastName} ${settings.firstName}`);
    });
  });

  const handleDrawerOpen = () => {
    props.setOpen(!props.open);
  };

  return (
    <MyAppBar position="absolute">
      <MyToolBar>
        <MyIconButton
          edge="start"
          color="inherit"
          aria-label="open drawer"
          onClick={handleDrawerOpen}
        >
          <MenuIcon />
        </MyIconButton>
        <MyTypography component="h1" variant="h6" color="inherit" noWrap>
          {document.title}
        </MyTypography>
        <MyTypography component="h1" variant="h6" color="inherit" align="right">
          {`${name} (Super Admin)`}
        </MyTypography>
      </MyToolBar>
    </MyAppBar>
  );
};

export default Header;
